//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import "vux";
import { mapState } from "vuex";
import { fetch } from "@/page/index";
import UserHeader from "./UserHeader";
import BaseNoticeItem from "../../components/BaseNoticeItem";

function isHttpPath(p) {
  return typeof p === "string" && /^https?:\/\//i.test(p.trim());
}

/**
 * 与登录用户信息 userInfo.userType 对应：
 * EXTERNAL — 供应商；INSIDE — 采购方（内部用户）
 * allowedUserTypes 为该菜单允许出现的用户类型列表
 */
function menuAllowedForUserType(slot, userType) {
  const allowed = slot.allowedUserTypes;
  if (!allowed || !allowed.length) return true;
  if (userType && allowed.indexOf(userType) !== -1) return true;
  // 未识别用户类型时，仅展示「双端」菜单，避免误显单端专属入口
  if (!userType && allowed.length === 2) return true;
  return false;
}

/** 首页应用入口；图标互不相同；allowedUserTypes 控制供应商/采购方可见性 */
const HOME_APP_SLOTS = [
  {
    key: "archive",
    title: "档案查看",
    icon: "records",
    defaultPath: "/SupplierArchiveView",
    allowedUserTypes: ["EXTERNAL"],
    codes: ["DACK"],
    names: ["档案查看", "档案"],
  },
  {
    key: "inspection",
    title: "实地评鉴",
    icon: "friends-o",
    defaultPath: "/LocaleInspectList",
    allowedUserTypes: ["INSIDE"],
    codes: ["LOCALE_INSPECT", "SDPJ", "SHKPJ", "XCCH"],
    names: ["实地评鉴", "现场考察", "考察"],
  },
  {
    key: "inquiry",
    title: "询价报价",
    icon: "newspaper-o",
    defaultPath: "/SupplierInquiryList",
    supplierPath: "/SupplierInquiryList",
    allowedUserTypes: ["EXTERNAL"],
    codes: ["BJLB", "XJBM", "XJBJ", "XJBJG"],
    names: ["询价报价", "询价", "报价"],
  },
  {
    key: "purchaseOrder",
    title: "采购订单",
    icon: "orders-o",
    defaultPath: "/PurOrderList",
    insidePath: "/PurOrderList",
    supplierPath: "/SupplierPurOrderList",
    allowedUserTypes: ["EXTERNAL", "INSIDE"],
    codes: ["DDCX", "DDQR", "CGDD"],
    names: ["采购订单", "订单查询", "订单确认"],
  },
  {
    key: "materialPlan",
    title: "到料计划",
    icon: "cluster-o",
    defaultPath: "/MaterialArrivalPlanHub",
    insidePath: "/PurDeliveryNoticeList",
    supplierPath: "/SupplierDeliveryNoticeList",
    allowedUserTypes: ["EXTERNAL", "INSIDE"],
    codes: ["DLJH", "DLLJ"],
    names: ["到料计划", "到料", "到货计划"],
  },
  {
    key: "delivery",
    title: "送货单",
    icon: "logistics",
    defaultPath: "/DeliveryList",
    allowedUserTypes: ["EXTERNAL", "INSIDE"],
    codes: ["SHD"],
    names: ["送货单"],
  },
  {
    key: "scanBindDelivery",
    title: "扫码绑定送货单",
    icon: "scan",
    defaultPath: "/ScanBindDeliveryNote",
    allowedUserTypes: ["EXTERNAL", "INSIDE"],
    codes: ["SMBDSHD"],
    names: ["扫码绑定送货单", "扫码绑定"],
  },
  {
    key: "statement",
    title: "对账单",
    icon: "search",
    defaultPath: "/AccountStmtList",
    allowedUserTypes: ["EXTERNAL", "INSIDE"],
    codes: ["DZD", "DZDJ", "JSM", "JSD"],
    names: ["对账单", "对账", "结算单"],
  },
  {
    key: "performance",
    title: "绩效查看",
    icon: "bar-chart-o",
    defaultPath: "/Performance",
    allowedUserTypes: ["EXTERNAL"],
    codes: ["GYSJXJG"],
    names: ["绩效查看", "绩效", "供应商绩效结果"],
  },
];

export default {
  data() {
    return {
      baseNoticeList: []
    };
  },
  components: {
    UserHeader,
    BaseNoticeItem
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo,
    }),
    homeAppMenus() {
      const userType =
        this.userInfo && this.userInfo.userType
          ? String(this.userInfo.userType)
          : "";
      // 首页入口写死在 HOME_APP_SLOTS，按 userType 控制可见性，不再依赖后端菜单缓存
      return HOME_APP_SLOTS.filter((slot) =>
        menuAllowedForUserType(slot, userType)
      ).map((slot) => {
        let toPath = slot.defaultPath;
        if (userType === "EXTERNAL" && slot.supplierPath) {
          toPath = slot.supplierPath;
        }
        if (userType === "INSIDE" && slot.insidePath) {
          toPath = slot.insidePath;
        }
        return {
          key: slot.key,
          menuName: slot.title,
          icon: slot.icon,
          toPath,
          isExternal: isHttpPath(toPath),
        };
      });
    },
  },
  created() {},
  activated: function () {},
  methods: {
    listNotice() {
      fetch.notice_listSummaryByPage({
        pageIndex: 1,
        pageRows: 10,
        userId: this.userInfo.userId,
        supplierId: this.userInfo.supplierId,
      }).then((res) => {
        this.baseNoticeList = res.data
      });
    },
    /**查看公告详情*/
    doShowNotice(notice) {
      this.$router.push({
        name: 'noticeDetailView',
        params: {noticeId: notice.noticeId},
        query: {}
      })
    },
    /**显示更多公告*/
    viewMoreBaseNotice(notice) {
      /*this.$router.push({
        name: 'testScan',
        params: {},
        query: {}
      })*/
      this.$router.push({
        name: 'baseNoticeList',
        params: {},
        query: {}
      })
    }
  },
  watch: {},
  mounted() {
    this.listNotice();
  },
};



// WEBPACK FOOTER //
// ./src/page/srm/home/Home.vue